<mat-dialog-content class="app-anamnesis-dialog__content">
    <div>
        <h2 mat-dialog-title class="app-anamnesis-dialog__title">
            {{ 'apps.patient.overview.anamnesis' | translate }}
        </h2>
        <app-anamnesis-form
            [formGroup]="anamnesisForm"
            [isActive]="true"
            [textareaMaxRows]="14"
            [isBedSideMode]="data.isBedSideMode"
        ></app-anamnesis-form>
    </div>

    <div class="app-anamnesis-dialog__actions">
        <button mat-button class="app-anamnesis-dialog__cancel" color="primary" mat-dialog-close>
            {{ 'apps.patient.overview.dialogCancel' | translate }}
        </button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="submitChange()">
            {{ 'apps.patient.overview.dialogSave' | translate }}
        </button>
    </div>
</mat-dialog-content>
